import {Component, OnInit} from '@angular/core';
import {LoaderService} from '../../../../services/loader/loader.service';
import {StatisticService} from '../../../../services/statistic/statistic.service';
import {ConversionReport} from '../../../../models/statistic/conversion-report';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {Paginator} from '../../../../tools/pagination/paginator';
import {MetaTitle} from '../../../../decorator/meta-title';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {RouterLink} from '@angular/router';
import {MoneyPipe} from '../../../../pipes/money/money.pipe';

@Component({
  selector: 'app-conversion-report',
  imports: [
    PaginatorComponent,
    NgForOf,
    DatePipe,
    RouterLink,
    NgIf,
    MoneyPipe
  ],
  templateUrl: './conversion-report.component.html',
  styleUrl: './conversion-report.component.scss'
})
@MetaTitle('Conversion report')
export class ConversionReportComponent implements OnInit {

  private filters: any;

  statistics: ConversionReport[] = [];
  paginator: Paginator = new Paginator();

  constructor(
    protected loader: LoaderService,
    private statisticService: StatisticService
  ) {
  }

  ngOnInit(): void {
    this.statistics = [];

    this.statisticService.$filters.subscribe((filters: any) => {
      this.filters = filters;
      this.fetchConversions();
    });
  }

  fetchConversions(): void {
    this.loader.startLoading();
    this.statisticService.fetchConversionReport(this.filters, this.paginator).subscribe((statistics: ConversionReport[]) => {
      this.statistics = statistics;
      this.loader.stopLoading();
    });
  }

}
